import { render, staticRenderFns } from "./RegionalSales.vue?vue&type=template&id=054c4de2&scoped=true&"
import script from "./RegionalSales.vue?vue&type=script&lang=js&"
export * from "./RegionalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c4de2",
  null
  
)

export default component.exports